import { render, staticRenderFns } from "./InAppValuation.vue?vue&type=template&id=b58d32a4&"
import script from "./InAppValuation.vue?vue&type=script&lang=js&"
export * from "./InAppValuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports